module.exports = __webpack_public_path__ + "img/selbsterfahrung_320.6b3ab9fb.webp";